import { UserClient } from "@amazon-connect/user";
import type { AmazonConnectProvider } from "@amazon-connect/core";
import type { ClientModule } from "../types";

/** UserClient: identity and instance metadata. Request-only, no events. */
export const userModule: ClientModule = {
  id: "user",
  label: "User",
  pkg: "@amazon-connect/user",
  clientExport: "UserClient",
  kind: "request-only",
  create: (provider: AmazonConnectProvider) =>
    new UserClient({ provider }) as unknown as Record<string, unknown>,
  events: [],
  requests: [
    { name: "getUserArn", args: [] },
    { name: "getUserRegion", args: [] },
    { name: "getInstanceId", args: [] },
  ],
};
